import type { LineItemField } from './invoiceDetailFormTypes';
import { fmtUsd, fmtUnitUsd } from './invoiceDetailFormFormatters';

export function createPartFieldGetters(getFieldValue: (index: number, field: LineItemField) => unknown) {
    const getStringValue = (index: number, field: LineItemField, defaultValue = '') =>
        String(getFieldValue(index, field) ?? defaultValue);

    const getPriceValue = (index: number, field: LineItemField, defaultValue = '0.00') =>
        (field === 'unitBuyPrice' ? fmtUnitUsd : fmtUsd)(
            typeof getFieldValue(index, field) === 'number'
                ? (getFieldValue(index, field) as number)
                : parseFloat(String(getFieldValue(index, field))) || 0,
        );

    return {
        getValue: getFieldValue,
        getStringValue,
        getPriceValue,
    };
}
